import { Photo } from "../components/web/WebAccess";

export const thumbnailOrOriginalUrl = (photo: Photo) => {
  const { url, thumbnailUrl } = photo;

  return thumbnailUrl ?? url;
};
